import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_STATISTICS_ACCOUNT_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_HOUSE_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL, GET_STATISTICS_ACTUALIZATION_OPTIC_RAPORT_EXCEL_API_URL, GET_STATISTICS_CABLE_ACCOUNT_API_URL, GET_STATISTICS_CABLE_CANTON_API_URL, GET_STATISTICS_CABLE_EXCEL_API_URL, GET_STATISTICS_INFRASTRUCTURE_ACCOUNT_API_URL } from '../OpticApiConfig';
import { loadingCanton } from '../LoadingData/LoadingDataTerritory';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { fontStyle } from '@mui/system';


//#region STYLE
const customStyles = {
  control: base => ({
    ...base,
    background: '#4b4b4b',
    borderRadius: '5px',
    fontSize: '16px',
    border: '1px solid #ffffff',
    
  }),
  singleValue: base => ({
    ...base,
    color: '#ffffff', 
  }),
  input: base => ({
    ...base,
    color: '#ffffff', 
  }),
  menu: base => ({
    ...base,
    background: '#4b4b4b',
    color: '#ececec', 
  }),
  option: (base, { isFocused }) => ({
    ...base,
    backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
    color: isFocused ? '#000000' : '#ececec', 
  }),
};
//#endregion 

const StatisticRaportIs = (user) => 
  {

  const [selectedCanton, setSelectedCanton] = useState('');
  const [resultCantonOptic, setCantonOptic] = useState([]);
  const [resultTotalHouses, setTotalHouses] = useState([]);
  const [resultCable, setResultCable] = useState([]);
  const [resultCableAccount, setResultCableAccount] = useState([]);
  const [resultComponent, setResultComponent] = useState({});
  const [error, setError] = useState(null);  
  const token = localStorage.getItem('token');
  const [canton, setCanton] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);


   // сегодня
  const today = new Date();
  // дата -7 дней
  const sevenDaysAgo = new Date();
  sevenDaysAgo.setDate(today.getDate() - 6);

  const [startDate, setStartDate] = useState(sevenDaysAgo); // "С"
  const [endDate, setEndDate] = useState(today);  
  const [displayRange, setDisplayRange] = useState(""); 
  const [displayRangeEnd, setDisplayRangeEnd] = useState("");    
  const [days, setDays] = useState("");           
       


  // Функция для форматирования дат
const formatDate = (date) => {
  return date.toLocaleDateString("ru-RU", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
};

const handleLoading = async () => {
  try {
    const token = localStorage.getItem("token");
    setLoading(true);
    setDisplayRange(`(${formatDate(startDate)} - ${formatDate(endDate)})`);
    setDisplayRangeEnd(`( на ${formatDate(endDate)})`);

    if (startDate && endDate) {
        const dayMs = 24 * 60 * 60 * 1000;

        const s = new Date(startDate);
        const e = new Date(endDate);

        // Берём только календарную дату (локальную), а разницу считаем в UTC — так не сломается на DST
        const sUTC = Date.UTC(s.getFullYear(), s.getMonth(), s.getDate());
        const eUTC = Date.UTC(e.getFullYear(), e.getMonth(), e.getDate());

        const diffDays = eUTC >= sUTC
          ? Math.floor((eUTC - sUTC) / dayMs) + 1   // +1 — чтобы включить оба дня
          : 0; // или поменяй местами, если хочешь поддерживать обратный порядок

        setDays(diffDays);
      }
    // Второй запрос
    const response = await axios.get(GET_STATISTICS_ACTUALIZATION_OPTIC_RAPORT_EXCEL_API_URL, {
      params: { startDate: startDate, endDate: endDate },
      headers: { Authorization: `Bearer ${token}` },
    });
    setCantonOptic(response.data);
    setLoading(false);
    setIsVisible(true);
    
 if (!response.data || response.data.length === 0) {
        alert("Нет данных за выбранную дату");
        setLoading(false);
        return;
 }
   
  } catch (error) {
    console.error("Ошибка при загрузке:", error);
    alert("Произошла ошибка при получении данных");
  } finally {
  }
};


//   const handleDownload = async () => {
//     setLoading(true);
//     try {
    
//       const newDate = new Date(selectedDate);
//       newDate.setDate(newDate.getDate() + 1); // Добавляем 1 день


//       const formattedDate = newDate.toISOString().split("T")[0];

//       const response = await axios.get(`${GET_STATISTICS_ACTUALIZATION_OPTIC_EXCEL_API_URL}`, {
//         params: { date: formattedDate },
//         headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }, 
//       });

//       // Переименование ключей
//       const formattedData = response.data.map(item => ({
//         "Округ": item.canton,
//         "Регион": item.region,
//         "Ветка": item.area,
//         "Кол. оптики": item.highwayLineIdCount,
//         "Актуализировано": item.documentCount,       
//       }));
 
//       if (!response.data || response.data.length === 0) {
//         alert("Нет данных за выбранную дату");
//         setLoading(false);
//         return;
//       }

   
//     const worksheetAccount = XLSX.utils.json_to_sheet(formattedData);
    
// const workbook = XLSX.utils.book_new();
// XLSX.utils.book_append_sheet(workbook, worksheetAccount, "Статистика актуализация");


// const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
// const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
// const newDate2 = new Date(selectedDate);
// newDate.setDate(newDate2.getDate() - 1); // Вычитаем 1 день

// // Форматируем дату в ISO-формате и извлекаем только дату
// const formattedDateMinusOne = newDate2.toISOString().split("T")[0];

// saveAs(blob, `Статистика_актуализация_${formattedDateMinusOne}.xlsx`);

//     } catch (error) {
//       console.error("Ошибка загрузки данных:", error);
//       alert("Ошибка загрузки данных");
//     }
//     setLoading(false);
//   };
  

   useEffect(() => {
        loadingCanton(setCanton); 
      }, []); 
  

   // Обработчик нажатия на кнопку
   const handleButtonClick = async () => {
    if (!selectedCanton) {
      setError('Пожалуйста, выберите округ.');
      return;
    }
  
    try {
      setError(null); 
  
      const response = await axios.get(GET_STATISTICS_ACTUALIZATION_OPTIC_API_URL, {
        headers: { Authorization: `Bearer ${token}` },
        params: { canton: selectedCanton }
      });
  
      setCantonOptic(response.data);
      setIsVisible(true);
    } catch (error) {
      console.error(error);
      setError('Произошла ошибка при загрузке данных.');
    }
  };


 

  return (
    <>
    
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>  
    <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />

      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
      <label className='textTitleDrawer' style={{ fontSize: "20px", marginLeft: "10px", textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>Рапорт ИС</label>
     

          <div className='address-summary'
            style={{
              textAlign: "center",
              paddingTop: "5px",
              paddingBottom: "5px",
              paddingLeft: "20px",
              paddingRight: "20px",
             
              float: "right", 
              display: "flex",
              borderRadius: "10px",
              flexDirection: "row", 
              alignItems: "center", 
            }}
          >
            <label style={{fontWeight:'bold', textShadow: '2px 2px 4px rgb(39, 39, 39)',color:'rgba(180, 180, 180, 1)'}}>C</label>
          <DatePicker
            selected={startDate}
             onChange={(date) => setStartDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Выберите дату"
            className="inputDescriptionModal"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            shouldCloseOnSelect={false}
            open={false}
          />
          <label style={{textShadow: '2px 2px 4px rgb(39, 39, 39)',fontWeight:'bold', marginLeft:'10px', color:'rgba(180, 180, 180, 1)'}}>по</label>
           <DatePicker
            selected={endDate}
            onChange={(date) => setEndDate(date)}
            dateFormat="yyyy-MM-dd"
            placeholderText="Выберите дату"
            className="inputDescriptionModal"
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            shouldCloseOnSelect={false}
            open={false}
          />

          <button className='buttonAutoTopology' onClick={handleLoading}  disabled={loading}  style={{ marginLeft: "10px",  marginTop: "0px" }}>
          {loading ? "Загрузка..." : "Отобразить"}
          </button>
        </div>
        
      </div>
      <hr className="horizontalLineDrawer" style={{ marginTop: "0px", marginBottom:'0px' }} />
    </div>
   
{isVisible && (
    <div style={{ display: 'flex', gap: '10px' }}>

      {/* Актуализация домов */}
      <div  className="scroll-container" style={{  marginTop: '0px', maxWidth:"800px",   height: '80vh', overflowY: 'auto', paddingBottom: '10px' }}>       
        <table className="results-table" style={{ boxShadow: "0 4px 8px rgba(255, 255, 255, 0.8)" }}> 
          <thead>
          <tr>
          <td colSpan="4" 
       style={{
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 'bold',      
        backgroundImage: 'linear-gradient(to right, rgb(56, 56, 56), #434343)',
      }}>
         
   <label style={{textShadow: '2px 2px 4px rgb(39, 39, 39)'}}>За период {displayRange}</label> 
   </td>
          </tr>
            <tr>
              
    <th>Округ</th>
    <th>Регион</th>
   
    <th> Воздушек / {days} д.</th>
    <th>Актуализировано / {days} д.</th>
  </tr>
           
          </thead>
          <tbody>
            {resultCantonOptic.length === 0 ? (
              <tr>
               <td colSpan="4" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
               resultCantonOptic.map((item, index) => {
      return (
        <tr>
          <td style={{textShadow: '2px 2px 4px rgb(39, 39, 39)' }}>{item.canton}</td>
          <td style={{textShadow: '2px 2px 4px rgb(39, 39, 39)',  textAlign: 'center' }}>{item.region}</td>
          <td
            style={{
              textShadow: '2px 2px 4px rgb(39, 39, 39)',
              textAlign: 'center',
              color: item.last7Days_CableCount === 0 ? '#e0656f' : '#5bcc87',
            }}
          >
            {item.last7Days_CableCount}
          </td>
          <td
            style={{
              textShadow: '2px 2px 4px rgb(39, 39, 39)',
              textAlign: 'center',
              color: item.last7Days_DocumentCount === 0 ? '#e0656f' : '#5bcc87',
            }}
          >
            {item.last7Days_DocumentCount}
          </td>
          
         </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>



      <div  className="scroll-container" style={{ flex: 1, marginTop: '0px', maxWidth:"800px",   height: '80vh', overflowY: 'auto', paddingBottom: '10px' }}>       
        <table className="results-table" style={{ boxShadow: "0 4px 8px rgba(255, 255, 255, 0.8)" }}> 
          <thead>
          <tr>
          <td colSpan="5" 
       style={{
        textAlign: 'center',
        fontSize: '14px',
        fontWeight: 'bold',      
        backgroundImage: 'linear-gradient(to right, rgb(56, 56, 56), #434343)',
      }}>     
      
        <label style={{textShadow: '2px 2px 4px rgb(39, 39, 39)'}}>Всего {displayRangeEnd}</label> 
      </td>
      </tr>
      <tr>
        <th>Округ</th>
        <th>Регион</th>
        <th>Воздушек</th>
        <th>Актуализировано</th>
        <th>%</th>
      </tr>
           
          </thead>
          <tbody>
            {resultCantonOptic.length === 0 ? (
              <tr>
               <td colSpan="5" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
               resultCantonOptic.map((item, index) => {
      return (
        <tr>
          <td>{item.canton}</td>
          <td>{item.region}</td>
          <td
            style={{
              textShadow: '2px 2px 4px rgb(39, 39, 39)',
              textAlign: 'center',
              color: item.highwayLineIdCount === 0 ? '#e0656f' : '#5bcc87',
            }}
          >
            {item.highwayLineIdCount}
          </td>

          <td
            style={{
              textShadow: '2px 2px 4px rgb(39, 39, 39)',
              textAlign: 'center',
              color: item.documentCount === 0 ? '#e0656f' : '#5bcc87',
            }}
          >
            {item.documentCount}
          </td>
         
        <td
          style={{
            textShadow: '2px 2px 4px rgb(39, 39, 39)',
            
            color:
              item.percentTotal === 0
                ? "#e0656f"     // если 0
                : item.percentTotal === 100
                ? "#5bcc87"  // если 100
                : "orange" // если больше 0, но меньше 100
          }}
        >
          {item.percentTotal}%
        </td>
        
         </tr>
              );
            })
          )}
          </tbody>
        </table>
      </div>
  </div>
       )}
      </>
  );
};

export default StatisticRaportIs;
